import useBusinessNavigate from '../../lib/useBusinessNavigate.js';
import { useEffect } from 'react';

const BusinessIndexPage = ({}) => {
    const navigate = useBusinessNavigate();

    useEffect(() => {
        navigate(`/calendar`);
    }, []);
};

export default BusinessIndexPage;
